import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.sort.js";
import { dbDataHandle } from '@/store/function/common/index';
import { getBillsApi, getWriteBillsApi } from '@/api';
import { isDateAfterToday } from '@/utils/datetime';

import { DateTime } from 'luxon';
import downloadCsv from 'download-csv';
export default {
  name: 'Monitor',
  props: {
    filename: {
      type: String,
      default: '下載檔案'
    }
  },
  data: function data() {
    return {
      hasNoData: false,
      changeMonitoringIndex: null,
      lastDayInput: DateTime.local().setZone('Asia/Taipei').toFormat('yyyy-MM-01'),
      nextDayInput: DateTime.local().setZone('Asia/Taipei').toFormat('yyyy-MM-dd'),
      kWhInput: 900,
      monitorData: [],
      monitorChart: {
        chart: {
          height: 350,
          backgroundColor: null,
          events: {
            load: function load() {
              this.showLoading();
            }
          }
        },
        credits: {
          enabled: false
        },
        title: {
          text: ''
        },
        xAxis: {
          categories: []
        },
        plotOptions: {
          series: {
            dataLabels: {
              enabled: true
            }
          }
        },
        legend: {
          layout: 'horizontal',
          align: 'center',
          verticalAlign: 'top',
          floating: false
        },
        yAxis: [{
          title: {
            text: '度數 (kWh)'
          }
        }, {
          title: {
            text: '差異 (%)'
          },
          opposite: true
          // max: 0.13
        }],
        tooltip: {
          shared: true
        },
        series: [{
          color: 'rgb(124,181,236)',
          type: 'column',
          name: '監控度數 (kWh)',
          data: [],
          yAxis: 0
        }, {
          color: 'rgb(31, 209, 150)',
          type: 'column',
          name: '電費單度數 (kWh)',
          data: [],
          yAxis: 0
        }, {
          color: 'rgb(255, 192, 0)',
          name: '差異 (%)',
          data: [],
          yAxis: 1
        }],
        responsive: {
          rules: [{
            condition: {
              maxWidth: 500
            },
            chartOptions: {
              legend: {
                layout: 'horizontal',
                align: 'center',
                verticalAlign: 'bottom',
                y: 0
              }
            }
          }]
        }
      },
      monitorDataForExcel: []
    };
  },
  methods: {
    isDateAfterToday: isDateAfterToday,
    dbDataHandle: dbDataHandle,
    checkDeleteMonitorData: function checkDeleteMonitorData(index) {
      var _this = this;
      this.$swal.fire({
        title: "\u78BA\u5B9A\u8981\u522A\u9664?",
        showDenyButton: true,
        showCancelButton: false,
        confirmButtonText: "\u78BA\u5B9A",
        denyButtonText: "\u5426"
      }).then(function (result) {
        if (result.isConfirmed) {
          _this.monitorDataSplice(index);
        }
      });
    },
    monitorDataSplice: function monitorDataSplice(index) {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.monitorData.splice(index, 1);
                _context.next = 3;
                return _this2.writebills();
              case 3:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    monitorDataPush: function monitorDataPush() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var obj;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this3.lastDayInput !== '' && _this3.nextDayInput !== '' && _this3.kWhInput !== '' && _this3.nextDayInput > _this3.lastDayInput)) {
                  _context2.next = 7;
                  break;
                }
                obj = {
                  dateStart: _this3.lastDayInput,
                  dateEnd: _this3.nextDayInput,
                  genKwh: Number(_this3.kWhInput)
                };
                _this3.monitorData.push(obj);
                _context2.next = 5;
                return _this3.writebills();
              case 5:
                _context2.next = 8;
                break;
              case 7:
                _this3.$swal('請確認日期');
              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    renderData: function renderData() {
      var _this4 = this;
      this.monitorChart.xAxis.categories = [];
      this.monitorChart.series.forEach(function (x) {
        x.data = [];
      });
      this.monitorData.forEach(function (x) {
        _this4.monitorChart.xAxis.categories.push("".concat(x.dateStart, " ~ ").concat(x.dateEnd));
        // 圖表、表格 是共用 this.monitorData 資料，直接 dbDataHandle 改變原始資料，顯示處理過的數據
        x.kwhSum = x.kwhSum === null ? null : dbDataHandle(x.kwhSum);
        x.genKwh = x.genKwh === null ? null : dbDataHandle(x.genKwh);
        x.diffRate = x.diffRate === null ? null : dbDataHandle(x.diffRate);
        _this4.monitorChart.series[0].data.push(x.kwhSum);
        _this4.monitorChart.series[1].data.push(x.genKwh);
        _this4.monitorChart.series[2].data.push(x.diffRate);
      });
      this.hideHighChartLoading();
    },
    hideHighChartLoading: function hideHighChartLoading() {
      this.$nextTick(function () {
        if (this.$refs && this.$refs.chart) {
          this.$refs.chart.chart.hideLoading();
        }
      });
    },
    downloadAnalysis: function downloadAnalysis() {
      var downloadArr = [];
      var fields = ['name'];
      fields = fields.concat(this.monitorChart.xAxis.categories);
      this.monitorChart.series.forEach(function (x) {
        downloadArr.push({
          name: x.name
        });
      });
      var download = [];
      this.monitorChart.series.forEach(function (_) {
        download.push({
          data: []
        });
      });
      this.monitorDataForExcel.forEach(function (obj) {
        var kwhSum = obj.kwhSum === null ? null : obj.kwhSum;
        var genKwh = obj.genKwh === null ? null : obj.genKwh;
        var diffRate = obj.diffRate === null ? null : obj.diffRate;
        download[0].data.push(kwhSum);
        download[1].data.push(genKwh);
        download[2].data.push(diffRate);
      });
      this.monitorChart.xAxis.categories.forEach(function (x, xindex) {
        downloadArr.forEach(function (y, yindex) {
          y["".concat(x)] = download[yindex].data[xindex];
        });
      });
      downloadCsv(downloadArr, fields, this.filename);
    },
    showMonitorModal: function showMonitorModal() {
      this.$bvModal.show('monitorModal');
    },
    getbills: function getbills() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _monitorData$data, _monitorData$data$dat, monitorData;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this5.monitorChart.series.forEach(function (x) {
                  x.data = [];
                });
                _context3.prev = 1;
                _context3.next = 4;
                return getBillsApi(_this5.$route.query.fid, _this5.$route.query.siteName);
              case 4:
                monitorData = _context3.sent;
                if (monitorData !== null && monitorData !== void 0 && (_monitorData$data = monitorData.data) !== null && _monitorData$data !== void 0 && (_monitorData$data$dat = _monitorData$data.data) !== null && _monitorData$data$dat !== void 0 && _monitorData$data$dat.length) {
                  // 複製 monitoringData、monitorDataForExcel 不能 refer 同個 data
                  // renderData() 會改動 monitorData 資料

                  // 下載資料用
                  _this5.monitorDataForExcel = monitorData.data.data.map(function (item) {
                    var copy = Object.assign({}, item, {
                      diffRate: dbDataHandle(Math.abs(item.kwhSum - item.genKwh) / item.kwhSum * 100)
                    });
                    return copy;
                  });

                  // 顯示圖表、表格用，copy 避免改動到 rawData (monitorData.data.data)
                  _this5.monitorData = monitorData.data.data.map(function (item) {
                    var copy = Object.assign({}, item, {
                      diffRate: dbDataHandle(Math.abs(item.kwhSum - item.genKwh) / item.kwhSum * 100)
                    });
                    return copy;
                  });
                  _this5.renderData();
                  _this5.hasNoData = false;
                }
                _context3.next = 13;
                break;
              case 8:
                _context3.prev = 8;
                _context3.t0 = _context3["catch"](1);
                console.log('getbills error: ', _context3.t0);
                _this5.hasNoData = true;
                _context3.t0.msg && _this5.$swal(_context3.t0.msg);
              case 13:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, null, [[1, 8]]);
      }))();
    },
    writebills: function writebills() {
      var _this6 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var _writebills$data;
        var data, writebills;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = _this6.monitorData.map(function (x) {
                  return {
                    dateStart: x.dateStart,
                    dateEnd: x.dateEnd,
                    genKwh: x.genKwh
                  };
                }).sort(function (x, y) {
                  return x.dateStart > y.dateStart ? 1 : -1;
                });
                _context4.next = 3;
                return getWriteBillsApi(_this6.$route.query.siteName, data);
              case 3:
                writebills = _context4.sent;
                if (!(writebills !== null && writebills !== void 0 && (_writebills$data = writebills.data) !== null && _writebills$data !== void 0 && _writebills$data.success)) {
                  _context4.next = 7;
                  break;
                }
                _context4.next = 7;
                return _this6.getbills();
              case 7:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  },
  created: function created() {
    var _this7 = this;
    return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
      return _regeneratorRuntime().wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return _this7.getbills();
            case 2:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }))();
  }
};